import { Box, Typography } from "@mui/material";
import RuleIcon from "@mui/icons-material/Rule";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import MyMagicPanelShell from "../shared/MyMagicPanelShell";
import { ENRICHMENT_RULES } from "../data/enrichmentRules";

const ICONS = { Building: BusinessIcon, People: PeopleIcon };

const sx = {
  cardList: { display: "flex", flexDirection: "column", gap: 1 },
  card: (selected, accent) => (theme) => ({
    border: `1px solid ${selected ? accent : theme.palette.divider}`,
    borderRadius: 2,
    p: 1.5,
    backgroundColor: selected ? `${accent}14` : theme.palette.background.paper,
    borderLeft: "3px solid",
    borderLeftColor: selected ? accent : "divider",
    cursor: "pointer",
    "&:hover": { boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    transition: "all 0.15s ease",
  }),
  name: { fontSize: 14, fontWeight: 700, color: "text.primary" },
  summary: { fontSize: 12, color: "text.secondary", lineHeight: 1.4, mt: 0.5 },
  meta: { fontSize: 11, color: "text.secondary", mt: 0.5 },
};

const EnrichmentRulesListPanel = ({ selectedId, onSelect, onClose }) => (
  <MyMagicPanelShell
    onClose={onClose}
    titleContent={
      <Box sx={{ display: "flex", alignItems: "center", flex: 1, gap: 0.5 }}>
        <RuleIcon sx={{ fontSize: 16, color: "#0ea5e9" }} />
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "text.primary" }}>
          Enrichment Rules
        </Typography>
      </Box>
    }
    footerLeft={
      <Typography sx={{ color: "text.secondary", fontSize: 11 }}>
        {ENRICHMENT_RULES.length} rule{ENRICHMENT_RULES.length !== 1 ? "s" : ""}
      </Typography>
    }
  >
    <Box sx={sx.cardList}>
      {ENRICHMENT_RULES.map((rule) => {
        const Icon = ICONS[rule.icon] || RuleIcon;
        const selected = selectedId === rule.id;
        return (
          <Box key={rule.id} sx={sx.card(selected, rule.accent)} onClick={() => onSelect(rule)}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <Icon sx={{ fontSize: 16, color: rule.accent }} />
              <Typography sx={sx.name}>{rule.name}</Typography>
            </Box>
            <Typography sx={sx.summary}>{rule.summary}</Typography>
            <Typography sx={sx.meta}>
              Scope: {rule.scope} · {rule.sources.length} sources · {rule.fieldsWritten.length} fields written
            </Typography>
          </Box>
        );
      })}
    </Box>
  </MyMagicPanelShell>
);

export default EnrichmentRulesListPanel;
